import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { ClaimService } from '@app-core';

@Injectable({
    providedIn: 'root',
})
export class SuccessRouteGuard implements CanActivate {
    private readonly claimService = inject(ClaimService);
    private readonly router = inject(Router);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        // Check if the user has successfully submitted a claim
        const isSubmissionSuccessful = this.claimService.getSubmissionSuccessful();

        // If the user has not successfully submitted a claim, redirect to the parent response page
        if (!isSubmissionSuccessful) {
            this.router.navigate(['/parent-response']);
            return false;
        }

        // Allow access to the route if the user has successfully submitted a claim
        return true;
    }
}
